export const routes = {
    HOME: "/",
    COLLECTIONS: "/collections"
}